import {useState} from 'react';
import {Collections, TicketStatus} from '../../..';
import {useUserInfo} from '../../../hooks';
import {useTicketEditContainer} from './useTicketEditContainer';

export const useCommentWarnings = (isNewComment: boolean) => {
  const {commentsCollection} = useTicketEditContainer();
  const {isPortal} = useUserInfo();

  const [shouldShowInternalCommentWarning, setShouldShowInternalCommentWarning] = useState(false);
  const [shouldShowPublicCommentWarning, setShouldShowPublicCommentWarning] = useState(false);

  const hideWarnings = () => {
    setShouldShowInternalCommentWarning(false);
    setShouldShowPublicCommentWarning(false);
  };

  const showWarning = () => {
    if (shouldShowWarningComponent) {
      if (commentsCollection === Collections.commentsInternal) {
        setShouldShowInternalCommentWarning(true);
      } else {
        setShouldShowPublicCommentWarning(true);
      }
    }
  };

  const shouldShowWarningComponent =
    !isPortal &&
    isNewComment &&
    !shouldShowInternalCommentWarning &&
    !shouldShowPublicCommentWarning;

  return {
    shouldShowInternalCommentWarning,
    shouldShowPublicCommentWarning,
    shouldShowWarningComponent,
    showWarning,
    hideWarnings,
  };
};

export const useTicketResolvedWarning = (ticketStatus: TicketStatus | undefined) => {
  const {isPortal} = useUserInfo();
  const [shouldShowWarningComponent, setShouldShowWarning] = useState(false);

  // Show warning if the ticket is not closed and the warning component is not shown yet
  const shouldShowWarning =
    !isPortal && !shouldShowWarningComponent && ticketStatus !== TicketStatus.Closed;

  return {
    shouldShowWarning,
    shouldShowWarningComponent:
      shouldShowWarningComponent && ticketStatus !== TicketStatus.Closed && !isPortal,
    setShouldShowWarning,
  };
};
